import { memo } from "react";

import { PixelPlaceholderLoader } from "@similarweb/ui-components";

import { LOADER_HEIGHT, LOADER_WIDTH } from "app/pages/activation/components/Topics/constants";
import { StyledTopicName } from "app/pages/activation/components/Topics/Topic/styles";

import { topicNameKeys } from "../automationKeys";

type TopicNameSchema = {
    name?: string;
    isLoading: boolean;
};

export const TopicName = memo(({ name, isLoading }: TopicNameSchema) =>
    !name && isLoading ? (
        <span data-automation={topicNameKeys.preLoader}>
            <PixelPlaceholderLoader
                height={LOADER_HEIGHT}
                width={LOADER_WIDTH}
            />
        </span>
    ) : (
        <StyledTopicName data-automation={topicNameKeys.name(name)}>{name}</StyledTopicName>
    ),
);

TopicName.displayName = "TopicName";
